module.exports = __webpack_public_path__ + "img/store-icons-google.5b125f39.svg";